export default "__VITE_ASSET__Bi16FVAO__"